module.exports = __webpack_public_path__ + "static/media/ellipsis-h.7d93bcd1.svg";